import React from "react";

import DashboardShell from "../dashboard/DashboardShell";

const Content = () => (
  <DashboardShell
    title="Levels"
    subtitle="Content footprint across every administrative level."
    clickRoute="/levels/first"
    breadCrumbDefault={false}
  />
);

export default Content;
